<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.44 21.1198C6.08754 21.1198 1.76001 16.7922 1.76001 11.4398C1.76001 6.0873 6.08754 1.75977 11.44 1.75977C16.7925 1.75977 21.12 6.0873 21.12 11.4398C21.12 16.7922 16.7925 21.1198 11.44 21.1198ZM11.44 2.89859C6.71389 2.89859 2.89883 6.71365 2.89883 11.4398C2.89883 16.1659 6.71389 19.9809 11.44 19.9809C16.1661 19.9809 19.9812 16.1659 19.9812 11.4398C19.9812 6.71365 16.1661 2.89859 11.44 2.89859Z"
      fill="#5E6A79"
    />
    <path
      d="M8.80005 15.3383V7.17188L15.84 11.2551L8.80005 15.3383ZM9.73872 8.76761V13.6956L13.9627 11.2081L9.73872 8.76761Z"
      fill="#5E6A79"
    />
  </svg>
</template>

<script>
export default {
  name: "IconPlay",
};
</script>

<style></style>
